import { Object3D } from 'three'

import { SimplePoseSmoother } from '../extras/SimplePostSmoother'

import { Avatar } from '../extras/Avatar'

import { Entity } from './Entity'

const quat = [0, 0, 0, 1]

export class PlayerRemote extends Entity {
  constructor(client, data) {
    super(client, data)

    this.avatar = new Avatar(this.client)
    // this.avatar.setVisible(data.visible)
    this.avatar.setVisible(true)
    this.avatar.setup(data.avatar)

    this.base = new Object3D()
    this.head = new Object3D()
    this.lHand = new Object3D()
    this.rHand = new Object3D()

    this.baseLerp = new SimplePoseSmoother()
    this.headLerp = new SimplePoseSmoother()
    this.lHandLerp = new SimplePoseSmoother()
    this.rHandLerp = new SimplePoseSmoother()

    this.client.setHot(this, true)
    this.unregisterVoice = this.client.media.registerEntity(this)
  }

  getVoiceTransform(pos, qua) {
    pos.copy(this.head.position)
    qua.copy(this.head.quaternion)
  }

  setVoiceActive(active) {
    // ...
  }

  modify(data) {
    if (data.hasOwnProperty('by')) {
      this.baseLerp.push([0, data.by, 0], quat)
    }
    if (data.hasOwnProperty('hp')) {
      this.headLerp.push(data.hp, data.hq)
    }
    if (data.hasOwnProperty('lp')) {
      this.lHandLerp.push(data.lp, data.lq)
    }
    if (data.hasOwnProperty('rp')) {
      this.rHandLerp.push(data.rp, data.rq)
    }
    if (data.hasOwnProperty('visible')) {
      this.avatar.setVisible(data.visible)
    }
  }

  equip(slot, item) {
    this.data.avatar[slot] = item
    this.avatar.setup(this.data.avatar)
  }

  update(delta) {
    this.baseLerp.sample(this.base.position, this.base.quaternion)
    this.headLerp.sample(this.head.position, this.head.quaternion)
    this.lHandLerp.sample(this.lHand.position, this.lHand.quaternion)
    this.rHandLerp.sample(this.rHand.position, this.rHand.quaternion)
    this.avatar.update(delta, this.base.position.y, this.head, this.lHand, this.rHand)
  }

  destroy() {
    this.avatar.destroy()
    this.client.setHot(this, false)
    this.unregisterVoice()
    this.unregisterVoice = null
  }
}
